import React from "react";
import Header from "../section/header/header";
import Banner from "../section/banner-carousel/banner";
import About from "../section/about-us/about";
import Promo from "../section/promo/promo";
import Newlaunch from "../section/newlaunch/newlaunch";
import Product from "../section/product/product";
import Ruko from "../section/ruko/ruko";
import Maps from "../section/maps/maps";
import Footer from "../section/footer/footer";
import "./home.scss";
import ScrollToHashElement from "./ScrollToHashElement";

const home = () => {
  return (
    <div className="home">
      <ScrollToHashElement />
      <Header />
      <Banner />
      <About />
      <Promo />
      <Newlaunch />
      <Product />
      <Ruko />
      <Maps />
      <Footer />
    </div>
  );
};

export default home;
